import { createReducer } from '@reduxjs/toolkit';

import getUsers from '../../thunks/users/getUsers';

const initialState = {
  loading: false,
  error: null,
  users: []
};

const getUsersReducer = createReducer(initialState, {
  [getUsers.pending]: (state) => ({
    ...state,
    loading: true,
    error: null
  }),
  [getUsers.fulfilled]: (state, { payload: users }) => ({
    ...state,
    loading: false,
    users
  }),
  [getUsers.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    users: []
  }),
});

export default getUsersReducer;
